import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import { FundRequestStatus } from '../../../app/models/Fund';
import useFundsRequestService from '../../../app/services/hooks/useFundsRequestService';
import DefaultModal from '../../../components/default/DefaultModal';
import IssueDateForm from './forms/IssueDateForm';

interface Props {
    fundRequestId: number;
    statuses: FundRequestStatus[];
    selectedStatus: FundRequestStatus;
    callbackSuccess?: () => void;
}

const FundRequestChangeStatus = ({ fundRequestId, statuses, selectedStatus, callbackSuccess }: Props) => {

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [selected, setSelected] = React.useState<FundRequestStatus>(selectedStatus);
    const [newStatus, setNewStatus] = React.useState<FundRequestStatus>(selectedStatus);
    const [showIssueDate, setShowIssueDate] = React.useState<boolean>(false);
    const { changeFundsRequestStatus } = useFundsRequestService();
    const [errorFields, setErrorFields] = React.useState<any>();


    const eventChangeStatus = {
        onSuccess: (response: ServiceResponse) => {
            if (hideLoading) hideLoading();
            if (callbackSuccess) callbackSuccess();

            useReactConfirmAlert().successAlert({
                title: 'Éxito',
                message: 'Se ha cambiado el estado de la solicitud #' + fundRequestId
            });
        },
        onError: (response: ServiceResponse) => {
            if (hideLoading) hideLoading();
            useReactConfirmAlert().errorAlert({
                title: 'Error',
                message: response.message
            });
            toast.error(response.message);
            if (callbackSuccess) callbackSuccess();
        },
        onFieldError: (errorFields: ServiceResponse) => {
            if (hideLoading) hideLoading();
            setErrorFields(errorFields.data);
        },
    };

    const showIssueDateModal = () => {
        setShowIssueDate(true);
    };

    const hideIssueDate = () => {
        setShowIssueDate(false);
    };

    const confirmChange = (confirmStatus: FundRequestStatus | null = null) => {

        setSelected(newStatus!);

        if(!confirmStatus){
            confirmStatus = newStatus
        }

        const _text =
            'Está a punto de cambiar el estado de la Solicitud #' +
            fundRequestId +
            ' a ' +
            (confirmStatus ? confirmStatus.label : '');

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, cambiar estado',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Cambiando estado...');
                        if (confirmStatus){ 
                            changeFundsRequestStatus(fundRequestId, confirmStatus, eventChangeStatus)
                        } else{
                            if (hideLoading) hideLoading();
                            setTimeout(() => {
                                useReactConfirmAlert().infoAlert({
                                    title: 'Cancelado',
                                    message: 'Solicitud no encontrada.'
                                });
                            }, 0);
                            setSelected(selectedStatus);
                        }
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El estado de la Solicitud no se ha cambiado.'
                            });
                        }, 0);
                        setSelected(selectedStatus);
                    }
                }
            }
        });
    };

    const changeStatus = (value: string) => {
        if (value == selected.id) return null;

        const _status = statuses.find((status: FundRequestStatus) => status.id == value);

        if (_status && _status?.id) {
            _status.status = _status.id;
            setNewStatus(_status);
        }

        if (_status?.status == "CONFIRM"){
            showIssueDateModal()
        } else{
            confirmChange(_status);
        }
    };

    if (!selectedStatus) return null;

    return (
        <>
            <select
                className="form-control"
                value={selected.id}
                onChange={(e) => changeStatus(e.target.value)}
            >
                <option value={selectedStatus.id}>{selectedStatus.label}</option>
                {statuses.map((status) => {
                    if(status.id !== selected.id)
                    return (
                        <option key={status.id} value={status.id}>
                            {status.label}
                        </option>
                    );
                })}
            </select>

            {showIssueDate && (
                <DefaultModal
                    show={showIssueDate}
                    handleClose={hideIssueDate}
                    title="Añadir fecha de emisión de las transferencias"
                    backdrop={true}
                    showFooter={false}
                >
                    <IssueDateForm
                        status={newStatus} 
                        setStatus={setNewStatus}
                        onSaved={confirmChange}
                        onCancel={hideIssueDate}
                        onError={hideIssueDate}      
                        errorFields={errorFields}
                    />
                </DefaultModal>
            )}
        </>
    );
};

export default FundRequestChangeStatus